export default {
  title:'두근두근! 니케 인기 투표! 인기투표 1위 코스튬 투표',
  time:'6월 29일(목) 12:00 ~ 7월 5일(수) 23:59',
  curp:'현재 득표수',
  bottips:'누적 득표수는 매일 18:00(UTC+9)에 업데이트됩니다.',
  toptips:'*해당 코스튬 이미지는 개발 중의 디자인인 관계로, <br>코스튬 외형과 포즈는 최종 단계에서 변경될 수 있습니다.',
  dvotet:'투표 옵션을 확인하여 주시기 바랍니다',
  dvotep:'[확인] 버튼을 클릭한 뒤에는 선택 사항을 수정할 수 없습니다.',
  cancel:'취소',
  confirm:'확인',
  dloginp:'최초 게임 접속 및 코스튬 투표 진행 시<br><strong>일반 모집 티켓 1장</strong>을 획득하실 수 있습니다. ',
  username:'이메일',
  password:'비밀번호',
  login:'로그인',
  register:'다운로드 및 회원가입',
  logintips:'*게임 접속 후 회원가입 필요',
  forgetPassword:'비밀번호를 잊어버렸습니다',
  logint:'닉네임을 확인하여 주십시오',
  server:'서버',
  nickname:'닉네임',
  logintip2:'*계정 1개당 1개의 닉네임만 연동할 수 있으며, 보상은 1회만 수령 가능합니다',
  rulet:'규칙',
  rp1:'이벤트 소개<br>진행 기간: 2023/06/29 12:00 (UTC+9) ~ 2023/07/05 23:59 (UTC+9)<br>이벤트 기간 동안 가장 마음에 드는 모더니아의 코스튬에 투표할 수 있습니다. 이벤트 종료 후 가장 높은 득표수를 기록한 코스튬을 제작하여 모든 지휘관님께 무료로 지급해 드립니다!',
  rp2:'이벤트 기간 동안 가장 마음에 드는 모더니아의 코스튬에 투표할 수 있습니다. 이벤트 종료 후 가장 높은 득표수를 기록한 코스튬을 제작하여 모든 지휘관님께 무료로 지급해 드립니다!<br>* 지급 일자는 공식 플랫폼을 통해 안내해 드릴 예정입니다.<br><br>참여 방법: <br>이벤트 기간 동안 가장 마음에 드는 모더니아의 코스튬에 1회 투표할 수 있습니다.<br>*투표 완료 후, 선택 사항을 수정할 수 없으니 참고하여 주시기 바랍니다.',
  rp3:'보상: <br>1. 코스튬 투표 완료 시 모집 티켓 1장을 드립니다.<br>2. 지정 커뮤니티에 첫 공유 시 모집 티켓 1장을 드립니다.<br>*보상은 계정당 1회 지급되오니, 게임 내 메일함을 통해 보상을 수령해 주시기 바랍니다.',
  rp4:'주의사항<br>1. 해당 코스튬 이미지는 개발 중의 디자인인 관계로, 코스튬 외형과 자세는 최종 단계에서 변경될 수 있습니다.<br>2. 게임 계정 접속 후 이벤트 참여 및 보상 수령 시, 계정 당 1개의 서버와 닉네임만 연동이 가능하오니 유의하여 주시기 바랍니다.<br>3. 투표 페이지의 득표수는 매일 18:00(UTC+9)에 업데이트됩니다.<br>4. 이벤트 참여로 획득한 게임 내 보상은 메일함을 통해 발송되며, 시스템 관계 상 보상 발송이 지연될 수 있는 점 양해 부탁드립니다. 보상의 메일함 보관 기간은 30일이오니, 기간 내에 수령해 주시기 바랍니다.',
  rp5:'최종 투표 결과는 7월 6일 18시(UTC+9)에 해당 페이지에서 발표합니다.',
  votebtn:'투표',
  surepara:'투표 포털에 액세스 시 로그인 자격 증명, 사용자 ID, 연결된 서버, 닉네임 및 투표(참여 데이터)를 수집하게 됩니다. 투표는 직접 연결되지 않고 통계에 기록되며, 참여 데이터는 싱가포르에 있는 당사 서버에 6개월 동안 저장된 후 삭제됩니다. 당사가 귀하의 개인 정보를 취급하는 방법에 대한 자세한 내용은 <a href="https://nikke-kr.com/privacyconsentform" target="blank" class="dicon5" title="">[개인 정보 보호 정책]</a>을 참고하여 주시기 바랍니다.',  plan1:'-디자인 A-',
  plan2:'-디자인 B-',
  plan3:'-디자인 C-',

  account_not_exist: '계정이 없습니다. 게임에서 계정을 생성하세요.',
  password_empty: '비밀번호를 입력하지 않았습니다.',
  pleaseLogIn: '먼저 로그인하세요.',
  password_not_set: '계정 비밀번호가 설정되어 있지 않습니다.',

  shareContent: `신비한 섬으로 떠나는 모험! 니케들과 섬에서 펼쳐지는 이야기를 즐기고 여름 전용 이벤트 혜택을 획득하세요!
  
  #NIKKE #니케 #NIKKE신비한섬으로떠나는모험
  `,

  BaseSystemError: '투표 시스템 오류',
  VoteDelNumNotEnough: '투표 기회가 부족합니다.',
  RoleInfoNotSaved: '캐릭터 정보를 저장하지 않았습니다.',
  NoRoleInfo: '캐릭터 정보를 찾을 수 없습니다.',
  RoleInfoHasSaved: '캐릭터 정보를 저장했습니다.',
  FlowHasNotBegin: '이벤트 시간이 아닙니다.',
  FlowHasEnd: '이벤트가 종료됐습니다.',
  MiddlewareFlowLock: '갱신이 너무 빈번합니다. 잠시 후 다시 시도하세요.',
  SignedDayNotEnough: '금일 해제 횟수를 모두 사용하였습니다.',
  HasSignedToday: '금일 해제 횟수를 모두 사용하였습니다.',
  GetGiftLimit: '패키지를 모두 수령했습니다',
  third_auth_failed: '서드파티 로그인 실패, 다시 시도하세요.',
  pls_input_info: '로그인 정보를 입력하세요.',
  serverError: '서버 오류',
  networkError: '네트워크 오류',
  GetRoleInfoAccountTypeErr: '계정 유형 오류',
  please_select: '선택하세요.',
  submitted_vote: '이미 투표하여 중복으로 투표할 수 없습니다.',
  share_failed: '공유 실패',
  open_in_browser: '다른 브라우저에서 여세요.',
  no_role_found: '캐릭터를 찾을 수 없습니다.',
  laodingPic: '이미지를 생성하고 있습니다…',
  loading: '로딩 중…',
  nv_vote_p: '투표 인기 순위가 가장 높은 코스튬을 제작하여 무료로 지급하여 드립니다!',
  open_in_browser: '다른 브라우저를 통해 열어주시기 바랍니다',
  logout: '로그아웃',
  privacy:'개인정보보호정책',
  cookies:'쿠키 정책',
  privacyLink:'https://nikke-kr.com/privacypolicy/',
  cookiesLink:'https://nikke-kr.com/cookiepolicy/',

  claimable: '수령 가능',
  claimed: '수령 완료',
  claimSucess: '수령 성공',
}